import React from 'react';
import { withTranslation } from 'react-i18next';

const Trimester = (props) => {
    let progresWidth = 0;
    let weeks = props.weeks;
    let trimesterText = ''
    if (props.timesterNo === 1) {
        if (weeks >= 13) {
            progresWidth = 100;
        } else {
            progresWidth = (weeks * 100) / 13
        }
        trimesterText = props.t('DueDateCalculator_FirstTrimester')
    }

    if (props.timesterNo === 2) {
        if (weeks >= 27) {
            progresWidth = 100;
        } else if (weeks > 13 && weeks < 27) {
            progresWidth = ((weeks - 13) * 100) / 14
        }
        trimesterText = props.t('DueDateCalculator_SecondTrimester')
    }

    if (props.timesterNo === 3) {
        if (weeks >= 40) {
            progresWidth = 100;
        } else if (weeks > 27 && weeks <= 40) {
            progresWidth = ((weeks - 27) * 100) / 13
        }
        trimesterText = props.t('DueDateCalculator_ThirdTrimester')
    }

    return (
        <div className="trimester-progress-bar">
            <div className="progress">
                <div className="progress-bar" style={{ "width": `${progresWidth}%` }}>
                   
                </div>
                
                {/* <div className="pin" style={{ "margin-left": `${progresWidth}%` }}></div> */}

            </div>
            <p className="trimester-level">
            {trimesterText}
			</p>

            <p className="trimester-month-detail">{props.trimesterData.fromDateData.monthShortName} {props.trimesterData.fromDateData.day} to {props.trimesterData.toDateData.monthShortName} {props.trimesterData.toDateData.day}
            </p>
        </div>
    )
}

export default withTranslation()(Trimester);
